import { TableCell } from "@mui/material";

interface ChildPartProcessColumnProps {
  isOpenOEMProcessColumn: boolean;
  setIsOpenOEMProcessColumn: React.Dispatch<React.SetStateAction<boolean>>;
  OEMColumn: { id: number; name: string }[];
  isOpenSpareProcessColumn: boolean;
  setIsOpenSpareProcessColumn: React.Dispatch<React.SetStateAction<boolean>>;
  spareColumn: { id: number; name: string }[];
  isOpenOEMPriceColumn: boolean;
  setIsOpenOEMPriceColumn: React.Dispatch<React.SetStateAction<boolean>>;
  isOpenSparePriceColumn: boolean;
  setIsOpenSparePriceColumn: React.Dispatch<React.SetStateAction<boolean>>;
}

const ChildPartProcessColumn = ({
  isOpenOEMProcessColumn,
  setIsOpenOEMProcessColumn,
  OEMColumn,
  isOpenSpareProcessColumn,
  setIsOpenSpareProcessColumn,
  spareColumn,
  isOpenOEMPriceColumn,
  setIsOpenOEMPriceColumn,
  isOpenSparePriceColumn,
  setIsOpenSparePriceColumn,
}: ChildPartProcessColumnProps) => {
  return (
    <>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Total Material Cost (THB/pcs)
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          bgcolor: isOpenOEMProcessColumn ? "secondary.light" : "secondary.main",
          cursor: "pointer",
        }}
        onClick={() => {
          setIsOpenOEMProcessColumn(!isOpenOEMProcessColumn);
        }}
      >
        OEM Process (THB/pcs)
      </TableCell>
      {isOpenOEMProcessColumn && (
        <>
          {OEMColumn?.sort((a, b) => a.id - b.id).map((process) => (
            <TableCell
              key={process.id}
              sx={{
                minWidth: 120,
                maxWidth: 120,
                borderRight: "1px solid #e0e0e0",
                borderLeft: "1px solid #e0e0e0",
                textAlign: "right",
                bgcolor: "primary.light",
              }}
            >
              {process.name} (THB/pcs)
            </TableCell>
          ))}
          <TableCell
            sx={{
              minWidth: 120,
              maxWidth: 120,
              borderRight: "1px solid #e0e0e0",
              borderLeft: "1px solid #e0e0e0",
              textAlign: "right",
              bgcolor: "primary.light",
            }}
          >
            Admin OEM Process
          </TableCell>
          <TableCell
            sx={{
              minWidth: 120,
              maxWidth: 120,
              borderRight: "1px solid #e0e0e0",
              borderLeft: "1px solid #e0e0e0",
              textAlign: "right",
              bgcolor: "primary.light",
            }}
          >
            Profit OEM Process
          </TableCell>
        </>
      )}
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          bgcolor: isOpenSpareProcessColumn ? "secondary.light" : "secondary.main",
          cursor: "pointer",
        }}
        onClick={() => {
          setIsOpenSpareProcessColumn(!isOpenSpareProcessColumn);
        }}
      >
        Spare Process (THB/pcs)
      </TableCell>
      {isOpenSpareProcessColumn && (
        <>
          {spareColumn
            ?.sort((a, b) => a.id - b.id)
            .map((process) => (
              <TableCell
                key={process.id}
                sx={{
                  minWidth: 120,
                  maxWidth: 120,
                  borderRight: "1px solid #e0e0e0",
                  borderLeft: "1px solid #e0e0e0",
                  textAlign: "right",
                  bgcolor: "primary.light",
                }}
              >
                {process.name} (THB/pcs)
              </TableCell>
            ))}
          <TableCell
            sx={{
              minWidth: 120,
              maxWidth: 120,
              borderRight: "1px solid #e0e0e0",
              borderLeft: "1px solid #e0e0e0",
              textAlign: "right",
              bgcolor: "primary.light",
            }}
          >
            Admin Spare Process
          </TableCell>
          <TableCell
            sx={{
              minWidth: 120,
              maxWidth: 120,
              borderRight: "1px solid #e0e0e0",
              borderLeft: "1px solid #e0e0e0",
              textAlign: "right",
              bgcolor: "primary.light",
            }}
          >
            Profit Spare Process
          </TableCell>
        </>
      )}
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          bgcolor: isOpenOEMPriceColumn ? "secondary.light" : "secondary.main",
          cursor: "pointer",
        }}
        onClick={() => {
          setIsOpenOEMPriceColumn(!isOpenOEMPriceColumn);
        }}
      >
        OEM Price (THB/pcs)
      </TableCell>
      {isOpenOEMPriceColumn && (
        <>
          <TableCell
            sx={{
              minWidth: 120,
              maxWidth: 120,
              borderRight: "1px solid #e0e0e0",
              borderLeft: "1px solid #e0e0e0",
              textAlign: "right",
              bgcolor: "primary.light",
            }}
          >
            Admin OEM
          </TableCell>
          <TableCell
            sx={{
              minWidth: 120,
              maxWidth: 120,
              borderRight: "1px solid #e0e0e0",
              borderLeft: "1px solid #e0e0e0",
              textAlign: "right",
              bgcolor: "primary.light",
            }}
          >
            Profit OEM
          </TableCell>
        </>
      )}
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          bgcolor: isOpenSparePriceColumn
            ? "secondary.light"
            : "secondary.main",
          cursor: "pointer",
        }}
        onClick={() => {
          setIsOpenSparePriceColumn(!isOpenSparePriceColumn);
        }}
      >
        Spare Price (THB/pcs)
      </TableCell>
      {isOpenSparePriceColumn && (
        <>
          <TableCell
            sx={{
              minWidth: 120,
              maxWidth: 120,
              borderRight: "1px solid #e0e0e0",
              borderLeft: "1px solid #e0e0e0",
              textAlign: "right",
              bgcolor: "primary.light",
            }}
          >
            Admin Spare
          </TableCell>
          <TableCell
            sx={{
              minWidth: 120,
              maxWidth: 120,
              borderRight: "1px solid #e0e0e0",
              borderLeft: "1px solid #e0e0e0",
              textAlign: "right",
              bgcolor: "primary.light",
            }}
          >
            Profit Spare
          </TableCell>
        </>
      )}
    </>
  );
};

export default ChildPartProcessColumn;
